import * as clientStorage from './client-storage';
import { StorageKey } from './client-storage';
import { getQueryParameter } from './query-parameters';

function getQueryAuthToken ():string {
  const jwtToken = getQueryParameter('access_token');
  if (jwtToken) {
    return decodeURIComponent(jwtToken);
  }

  const legacyToken = getQueryParameter('token');
  if (legacyToken) {
    return decodeURIComponent(legacyToken);
  }

  return '';
}

export function getAuthorizationHeader ():string {
  const queryAuthToken = getQueryAuthToken();
  if (queryAuthToken) {
    return queryAuthToken.startsWith('Bearer ')
      ? queryAuthToken
      : `Bearer ${queryAuthToken}`;
  }

  const storedToken = clientStorage.get(StorageKey.TOKEN);
  return storedToken ? `Bearer ${storedToken}` : '';
}